import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { ShipmentType, ShipmentTypeDescription } from '../../types';

export const getShipmentTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllShipmentType`,
    method: 'get',
  });
};

export type ShipmentTypesResponse = {
  codeId: ShipmentType;
  codeDesc: ShipmentTypeDescription;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentTypes = async (): Promise<ShipmentTypesResponse> => {
  const response: AxiosResponse<ShipmentTypesResponse> = await getShipmentTypesAPI();
  return response.data;
};
